export default __webpack_public_path__ + "static/huy-intro-953858bc0ce321cf6bdc6377d4da7b11.png";